// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as UserCard from "./UserCard.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";

function UserList(Props) {
  var customerAndPartnerDetails = Props.customerAndPartnerDetails;
  var selectUser = Props.selectUser;
  var userCardClick = Props.userCardClick;
  var dispatchUserSelected = Props.dispatchUserSelected;
  var setShowSidePanel = Props.setShowSidePanel;
  return React.createElement("div", {
              className: "c-user-list"
            }, ReasonReactUtils$Catalyst.listToReactArray(List.mapi((function (index, userData) {
                        return React.createElement(UserCard.make, {
                                    handle_click: userCardClick,
                                    selected: selectUser === index,
                                    userData: userData,
                                    index: index,
                                    handle_send_message_click: (function (param) {
                                        Curry._1(dispatchUserSelected, userData);
                                        return Curry._1(setShowSidePanel, true);
                                      }),
                                    key: String(index)
                                  });
                      }), customerAndPartnerDetails)));
}

var make = UserList;

export {
  make ,
  
}
/* react Not a pure module */
